import service from "@/libs/mediumService.js";

export const namespaced = true;

export const state = {
    feed: {},
    items: []
};

export const mutations = {
    SET_FEED(state, feed) {
        state.feed = feed;
    },
    SET_ITEMS(state, items) {
        state.items = items;
    }
};

export const actions = {
    medium({ commit }) {
        return new Promise((resolve, reject) => {
            service.getRSS().then(resp => {
                commit("SET_FEED", resp.feed);
                commit("SET_ITEMS", resp.items);
                resolve(resp);
            }).catch(err => {
                console.error(err);
                reject(err);
            });
        });
    },
    mediumFeed({ commit }) {
        return new Promise((resolve, reject) => {
            service.getRSS().then(resp => {
                commit("SET_FEED", resp.feed);
                resolve(resp.feed);
            }).catch(err => {
                console.error(err);
                reject(err);
            });
        });
    },
    mediumItems({ commit }) {
        return new Promise((resolve, reject) => {
            service.getRSS().then(resp => {
                commit("SET_ITEMS", resp.items);
                resolve(resp.items);
            }).catch(err => {
                console.error(err);
                reject(err);
            });
        });
    }
};

export const getters = {
    getFeed(state) {
        return state.feed;
    },
    getFeedImg(state) {
        return state.feed.image;
    },
    getFeedUrl(state) {
        return state.feed.url;
    },
    getItems(state) {
        return state.items;
    }
};
